"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uri_1 = require("../../uri");
var shared_1 = require("@cian/peperrors/shared");
var RequestTimeout = /** @class */ (function () {
    function RequestTimeout(opts) {
        this.waitPeriod = opts.timeout;
    }
    RequestTimeout.prototype.onRequest = function (uri) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.timeoutId = setTimeout(function () {
                reject(new shared_1.HttpTimeoutError("api " + uri_1.URI.stringifyURI(uri) + " not answers in " + _this.waitPeriod + " milliseconds"));
            }, _this.waitPeriod);
        });
    };
    RequestTimeout.prototype.onResponse = function () {
        this.resolve();
        clearTimeout(this.timeoutId);
    };
    return RequestTimeout;
}());
exports.RequestTimeout = RequestTimeout;
//# sourceMappingURL=requestTimeout.js.map